import {Component} from "@angular/core";
import {NgClass} from "@angular/common";
import {ChatComponent} from "./chat/chat.component";
import {MatIcon} from "@angular/material/icon";
import {EmployeeDataComponent} from "./employee-data/employee-data.component";

@Component({
	selector: "app-chat-bot",
	templateUrl: "./chat-bot.component.html",
	styleUrls: ["./chat-bot.component.scss"],
	imports: [NgClass, ChatComponent, MatIcon, EmployeeDataComponent],
})
export class ChatBotComponent {
	animate: boolean = false;
}
